import React, { Component } from 'react';

export default class UserTabs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 'tb_userinfo'
        };
        this.setActiveTab = this.setActiveTab.bind(this)
    }

    setActiveTab(state) {
        //console.log("active tab %s",state)
        //this.setState({activeTab: state })
    }

    render() {
       // console.log("state tab %s",this.state.activeTab);
        return  <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
            <li className="nav-item">
                <a className="nav-link active" onClick={this.setActiveTab.bind(this,'tb_userinfo')} data-toggle="tab" href="#tb_userinfo"
                   role="tab"><span className="d-block d-sm-none"><i className="fas fa-address-card"></i></span>
                    <span className="d-none d-sm-block">User Info</span>
                </a>
            </li>
            <li className="nav-item">
                <a className="nav-link" onClick={this.setActiveTab.bind(this,'tb_adduser')} data-toggle="tab" href="#tb_adduser" role="tab">
                   <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                    <span className="d-none d-sm-block">Add User</span>
                </a>
            </li>
            <li className="nav-item">
                <a className="nav-link" onClick={this.setActiveTab.bind(this,'tb_roles')} data-toggle="tab" href="#tb_roles" role="tab">
                  <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                    <span className="d-none d-sm-block">Roles</span>
                </a>
            </li>
            <li className="nav-item">
                <a className="nav-link" onClick={this.setActiveTab.bind(this,'tb_assignment')} data-toggle="tab" href="#tb_assignment" role="tab">
                    <span className="d-block d-sm-none"><i className="fas fa-thumbtack"></i></span>
                    <span className="d-none d-sm-block">Assignment</span>
                </a>
            </li>
            <li className="nav-item">
                <a className="nav-link" onClick={this.setActiveTab.bind(this,'tb_changepassword')} data-toggle="tab" href="#tb_changepassword"
                   role="tab"><span className="d-block d-sm-none"><i className="fas fa-key"></i></span>
                    <span className="d-none d-sm-block">Change Password</span>
                </a>
            </li>
        </ul>

    }

    onUpdate (data) { this.setState({ data }) }
}